import { UserAreaStatus } from 'src/models/userArea';
import { AreaId } from 'src/types/area';
import { GradeDto } from 'src/types/grade';
import { ProfessionId, ProfessionName } from 'src/types/profession';
import { ResumeDto } from 'src/types/resume';
import { SkillId } from 'src/types/skill';

export type ProfileSkillId = SkillId;

export enum ProfileGender {
    Male = 'MALE',
    Female = 'FEMALE',
    Unknown = 'UNKNOWN',
}

interface LevelDto {
    id: number;

    internal_id: string;
    name: string;
    rank: number;
}

interface ScoreDto {
    max: number;
    actual: number;
}

interface VerificationResultDto {
    type: string;
    status: string;
    score: ScoreDto;
}

interface ProfileSkillVerificationDto {
    id: ProfileSkillId;

    attempted_at: string;
    method: string;
    level: LevelDto;
    result: VerificationResultDto;
}

export interface ProfileSkillDto {
    id: ProfileSkillId;
    name: string;
    category: string;
    level: LevelDto;
    verifications: ProfileSkillVerificationDto[];
}

export interface ProfileProfessionDto {
    id: ProfessionId;
    name: ProfessionName;
    inCareer: boolean; // флаг есть ли данный id профессии в кп
}

export interface ProfileAreaDto {
    id: AreaId;
    status: UserAreaStatus;
}

export interface ProfileUserPhotoDto {
    avatar: string;
    big: string;
    preview: string;
}

export interface ProfileDto {
    firstName: string; // имя
    lastName: string; // фамилия
    fullName: string; // имя + фамилия
    fullNameLetters: string; // первые буквы имя + фамилия
    gender: ProfileGender;
    userPhoto: ProfileUserPhotoDto | null;
    phone: string | null;
    profession: ProfileProfessionDto | null;
    grade: GradeDto | null;
    skills: ProfileSkillDto[];
    activeResume: ResumeDto | null;
    resumes: ResumeDto[];
    area: ProfileAreaDto;
}

export interface ProfileUpdateDto {
    profession: {
        id: ProfessionId;
        name: ProfessionName;
    };
    grade: GradeDto | null;
}
